import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  
import { reactive } from 'vue';
import { statusCheck } from '../public';

export const useReportStore = defineStore('report', () => {
  const reportInfo = reactive({
    total_face_value: 0,
    total_commission: 0,
    transaction_count: 0,
    total_fees_paid: 0,
    daily_face_value: {},
    face_value_by_time_of_day: {},
    transaction_by_day_of_week: {},
    summary: {
      total_face_value: 0,
      number_of_transactions: 0,
      amount_settled: 0,
      amount_pending: 0,
      total_fees_paid: 0,
      total_refunds: 0,
    },
  });

  const fetchReportInfo = async (period = 'this_month', customStart = '', customEnd = '') => {
    try {
      const response = await useHttp().get('/api/driver/report/info', {
        params: {
          period,
          custom_start: customStart,
          custom_end: customEnd,
        },
      });
      if (statusCheck(response.data)) {
        Object.assign(reportInfo, response.data.result);
      } else {
        console.error('Failed to fetch report info:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching report info:', error);
    } 
  };

  return { reportInfo, fetchReportInfo };
});